export default __webpack_public_path__ + "static/media/No.3-3.2026adef.jpg";